(function () {
  'use strict';

  angular.module('autofocus').directive('autofocus', autofocus);

  autofocus.$inject = ['$timeout'];

  function autofocus($timeout) {
    var directive = {
      link: link,
      restrict: 'A',
      scope: {
        trigger: '=autofocus',
      },
    };
    return directive;

    function link(scope, element, attrs) {
      $timeout(function () {
        angular.element(element).focus();
      });

      if (scope.trigger) {
        scope.trigger.focus = function () {
          $timeout(function () {
            angular.element(element).focus();
          });
        };
      }
    }
  }
})();
